import { useTranslation } from 'react-i18next'

import { getQaSelector } from '../../../utils/common'
import { AIButtonContainedDark } from '../../AIButton'
import { BUTTON_HEIGHT_40 } from '../../Button'
import { ICON_COLOR, ICON_HEIGHT_16, IconNG } from '../../Icon'
import Text from '../../Text'
import { QA_NAME_GRETA_AI_CHAT_FINANCE_PREVIEW } from '../GretaAIChat.constants'
import { getGretaAIChatSupportEmailLink } from '../GretaAIChatLockedState'

import {
  GRETA_AI_CHAT_FINANCE_PREVIEW_BENEFITS,
  QA_NAME_GRETA_AI_CHAT_FINANCE_PREVIEW_SUPPORT,
} from './GretaAIChatFinancePreview.constants'

import * as styles from './GretaAIChatFinancePreview.module.css'

import DoneIcon from '../../../icons/done.svg'

function GretaAIChatFinancePreview() {
  const { t } = useTranslation()

  const supportLink = getGretaAIChatSupportEmailLink(
    t('Greta.FinancePreviewSubjectKey')
  )

  const qaProps = getQaSelector({
    value: QA_NAME_GRETA_AI_CHAT_FINANCE_PREVIEW,
  })

  return (
    <div {...qaProps} className={styles.preview}>
      <Text Element='div' className={styles.heading}>
        {t('Greta.FinancePreviewTitleKey')}
      </Text>
      <Text isSecondary Element='div' className={styles.description}>
        {t('Greta.FinancePreviewTextKey')}
      </Text>

      <ul className={styles.benefits}>
        {GRETA_AI_CHAT_FINANCE_PREVIEW_BENEFITS.map(benefit => (
          <li className={styles.benefit} key={benefit.leadKey}>
            <IconNG
              Icon={DoneIcon}
              className={styles.check}
              color={ICON_COLOR.FinanceAccent}
              size={ICON_HEIGHT_16}
            />
            <Text>
              <Text className={styles.lead}>{t(benefit.leadKey)}</Text>{' '}
              {t(benefit.textKey)}
            </Text>
          </li>
        ))}
      </ul>

      <AIButtonContainedDark
        Element='a'
        className={styles.support}
        dataProps={{ href: supportLink }}
        height={BUTTON_HEIGHT_40}
        qaName={QA_NAME_GRETA_AI_CHAT_FINANCE_PREVIEW_SUPPORT}
        text={t('Greta.LockedSupportButtonKey')}
      />
    </div>
  )
}

export default GretaAIChatFinancePreview
